import React from "react";

const MapMarkerDark = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.99998 6.66669C9.0795 6.66669 8.33331 7.41288 8.33331 8.33335C8.33331 9.25383 9.0795 10 9.99998 10C10.9205 10 11.6666 9.25383 11.6666 8.33335C11.6666 7.41288 10.9205 6.66669 9.99998 6.66669Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8524 17.8185C10.7705 17.904 10.7058 17.9706 10.6612 18.0162L10.6096 18.0687L10.5958 18.0827L10.5908 18.0877C10.5908 18.0877 10.5908 18.0877 10.5846 18.0817L10.5902 18.0883C10.4339 18.2452 10.2215 18.3334 9.99998 18.3334C9.77848 18.3334 9.56587 18.2449 9.40951 18.0881C9.40951 18.0881 9.40951 18.0881 9.41569 18.0819L9.40951 18.0881L9.40419 18.0827L9.39033 18.0687L9.33875 18.0162C9.29508 17.9725 9.23359 17.9083 9.15549 17.8268L9.14754 17.8185C8.98383 17.6476 8.75113 17.4009 8.4724 17.0948C7.91578 16.4836 7.17152 15.6313 6.4252 14.6705C5.68124 13.7128 4.92174 12.63 4.34453 11.559C3.77927 10.5102 3.33331 9.37324 3.33331 8.33335C3.33331 4.55082 6.32671 1.66669 9.99998 1.66669C13.6732 1.66669 16.6666 4.55082 16.6666 8.33335C16.6666 9.37324 16.2207 10.5102 15.6554 11.559C15.0782 12.63 14.3187 13.7128 13.5748 14.6705C12.8284 15.6313 12.0842 16.4836 11.5276 17.0948C11.2488 17.4009 11.0161 17.6476 10.8524 17.8185ZM6.66665 8.33335C6.66665 6.4924 8.15903 5.00002 9.99998 5.00002C11.8409 5.00002 13.3333 6.4924 13.3333 8.33335C13.3333 10.1743 11.8409 11.6667 9.99998 11.6667C8.15903 11.6667 6.66665 10.1743 6.66665 8.33335Z"
        fill="black"
      />
    </svg>
  );
};

export default MapMarkerDark;
